<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">
        <required-tag v-if="required"></required-tag>
        <span>
        {{ label }}
        </span>
      </div>
    </el-col>
    <el-col :span="spanSetting">
      <el-input type="text"
                :value="innerValue"
                v-on:change="onInputChange('commit', $event)"
                v-on:input="onInputChange('change', $event)"
                class="input-number">
      </el-input>
    </el-col>
    <el-col :span="spanSuffix">
      <div class="suffix-area">{{ suffix }}</div>
    </el-col>
  </el-row>
</template>

<script>
import RequiredTag from '@/components/RequiredTag.vue'
import Constants from './Constants'

export default {
  name: 'InputNumber',
  components: {
    requiredTag: RequiredTag
  },
  model: {
    prop: 'num',
    event: 'change'
  },
  props: {
    num: {
      type: Number
    },
    label: {
      type: String
    },
    suffix: {
      type: String
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    spanSuffix: {
      type: Number,
      default: Constants.SPAN_SUFFIX
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    num: function (newValue) {
      let onchange = false
      if (this.innerValue.length === 0) {
        onchange = (newValue !== 0)
      } else if (this.innerValue.substring(this.innerValue.length - 1, this.innerValue.length) === '.') {
        onchange = (newValue !== Number(this.innerValue + '0'))
      } else {
        onchange = (newValue !== Number(this.innerValue))
      }
      if (onchange) {
        this.innerValue = String(newValue)
      }
    }
  },
  mounted: function () {
    this.innerValue = String(this.num)
  },
  data: function () {
    return {
      innerValue: ''
    }
  },
  methods: {
    logging: function (val) {
      console.log(val)
    },
    onInputChange: function (event, value) {
      this.innerValue = value
      if (value.length === 0) {
        this.$emit(event, 0)
      } else if (value.substring(value.length - 1, value.length) === '.') {
        this.$emit(event, Number(value + '0'))
      } else {
        this.$emit(event, Number(value))
      }
    }
  }
}
</script>

<style>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 10px;
  margin-right: 10px;
}
.input-title {
  font-size: small;
}
div.suffix-area {
  text-align: left;
  font-weight: bold;
  font-size: medium;
  margin-top: 10px;
}
.input-number input.el-input__inner {
  font-size: medium;
  text-align: right;
}
</style>
